// extracted by mini-css-extract-plugin
export default {"testimonial-module":"mAZF70It--TestimonialOnlyText_testimonial-module__k9UIi","testimonialModule":"mAZF70It--TestimonialOnlyText_testimonial-module__k9UIi"};